// extracted by mini-css-extract-plugin
export default {"root":"ackRQyMB7UhARopOk20r","placeHolderShimmer":"dNKuEtg8oNTpI2X8N6Jp"};